/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, useStyleConfig } from '@chakra-ui/react';
import AOS from 'aos';

import Header from './header';
import Footer from './footer';
import SmartBanner from './smartBanner';
import useAmplitude from '../hooks/useAmplitude';
import '../../static/styles/main.scss';
import 'aos/dist/aos.css'; // You can also use <link> for styles

const Layout = ({ needBaseLayout, children }) => {
  const layoutContainerStyles = useStyleConfig('LayoutContainer');
  const [showSmartBanner, setShowSmartBanner] = useState(false);
  const amplitudeInstance = useAmplitude();

  useEffect(() => {
    AOS.init({ once: true });
    if (!amplitudeInstance) {
      console.error('amplitude is not initialized');
    }
  }, []);

  const closeSmartBanner = () => {
    window.sessionStorage.setItem('showSmartBanner', false);
    setShowSmartBanner(false);
  };

  useEffect(() => {
    const smartBannerStatus = window.sessionStorage.getItem('showSmartBanner');
    if (smartBannerStatus !== 'false' && document.body.clientWidth <= 768) {
      setShowSmartBanner(true);
    }
  }, []);

  return (
    <>
      {showSmartBanner && <SmartBanner closeSmartBanner={closeSmartBanner} />}
      <Header showSmartBanner={showSmartBanner} />
      <Box as="main" whiteSpace="pre-line" __css={needBaseLayout ? layoutContainerStyles : null}>
        {children}
      </Box>
      <Footer />
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  needBaseLayout: PropTypes.bool,
};
Layout.defaultProps = {
  needBaseLayout: false,
};

export default Layout;
